import React, { useState } from "react";
import { Button, Container, CopyValue, Modal, Toast } from "../../../../../Components";
import { apis, get } from "../../../../../Utils/axios";

function TemporaryPassword() {
	const [TempPassword, setTempPassword] = useState();
	const [Loader, setLoader] = useState();

	const getTempPassword = () => {
		setLoader(true);
		get(apis.getTempPassword, {}, (r, e) => {
			if (r) {
				setLoader();
				setTempPassword(r.tempPassword?.uuid);
			} else if (e) {
				Toast.handleError(e);
				setLoader();
			}
		});
	};

	return (
		<>
			<Container variant="outlined" className="flex flex-col justify-between h-full">
				<h4 className="mb-2">Temporary Password</h4>
				<div className="mb-4 text-xs text-secondary">Share one-time access safely for short support windows. Valid for 24 hours and one use only.</div>
				<div className="flex flex-col items-start gap-3 sm:flex-row sm:items-center">
					<img src="https://cdn.travelwings.com/assets/corp/images/intros/buddy.png" alt="Buddy" className="w-20 h-20 rounded-lg object-cover" />
					<div className="text-sm">Need someone to access your account briefly? Generate a temporary password and share it securely.</div>
				</div>
				<div className="flex gap-x-4 mt-4">
					<Button loading={Loader} onClick={getTempPassword} variant="success" className="w-full sm:w-auto">
						Generate Password
					</Button>
				</div>
			</Container>
			<Modal open={TempPassword} onClose={() => setTempPassword()}>
				<div className="p-8 text-center">
					<h1>Temporary Password</h1>
					<div className="mt-2 text-label">Remember this temporary password is valid only for 24 hours and can be used only once.</div>
					<CopyValue className="mt-4 text-sm flex-center">{TempPassword}</CopyValue>
				</div>
			</Modal>
		</>
	);
}

export default TemporaryPassword;
